import React from 'react';

import { createCn } from 'bem-react-classname';

import { Footer } from '@components/Footer';
import { Header } from '@components/Header';

import './BasicLayout.scss';

type Props = {
    children: React.ReactNode;
    showHeader?: boolean;
};

const cn = createCn('container');
const wrapper = createCn('wrapper');

export const BasicLayout: React.FC<Props> = ({ showHeader, children }) => (
    <div className={wrapper()}>
        <div className={cn()}>
            {showHeader && <Header />}
            <main className={cn('main', { showHeader })}>{children}</main>
        </div>
        <Footer />
    </div>
);
